import { BELL_NOTIFICATION } from "../actions/type.action";
const initialAuth = {
  task: [{projectTitle:'', tasks:[{}]}],
};

export const bellReducer = (state = initialAuth, action) => {
  switch (action.type) {
  case BELL_NOTIFICATION:
    // console.log('bell', action.payload);
    return {
      ...state,
      task: action.payload,
    };

  default:
    return state;
  }
};
